import { DistanceUnit, SpeedUnit } from 'src/api/types/units'
import SETTINGS from 'src/settings'

export enum Heatmap {
  Destination = 'destination',
  Origin = 'origin',
  Trips = 'trips',
}

const KM_TO_M = 1000
const KM_TO_MILES = 0.621371
const KMH_TO_MS = 0.277778

export const SECONDS_IN_MINUTE = 60 // in seconds

export const DEFAULT_MIN_DURATION = SETTINGS.app.filter_trips_min_duration // in minutes

export const DEFAULT_MAX_DURATION = SETTINGS.app.filter_trips_max_duration // in minutes

const round_nb = SETTINGS.app.filter_trips_step ? 1 / SETTINGS.app.filter_trips_step : 1

export const DEFAULT_MIN_DISTANCE = {
  [DistanceUnit.Kilometer]: SETTINGS.app.filter_trips_min_distance_km,
  [DistanceUnit.Meter]: SETTINGS.app.filter_trips_step
    ? Math.round(SETTINGS.app.filter_trips_min_distance_km * KM_TO_M * round_nb) / round_nb
    : Math.round(SETTINGS.app.filter_trips_min_distance_km * KM_TO_M),
  [DistanceUnit.Mile]: SETTINGS.app.filter_trips_step
    ? Math.round(SETTINGS.app.filter_trips_min_distance_km * KM_TO_MILES * round_nb) / round_nb
    : Math.round(SETTINGS.app.filter_trips_min_distance_km * KM_TO_MILES),
}

export const DEFAULT_MAX_DISTANCE = {
  [DistanceUnit.Kilometer]: SETTINGS.app.filter_trips_max_distance_km,
  [DistanceUnit.Meter]: Math.round(SETTINGS.app.filter_trips_max_distance_km * KM_TO_M),
  [DistanceUnit.Mile]: Math.round(SETTINGS.app.filter_trips_max_distance_km * KM_TO_MILES),
}

export const DEFAULT_MIN_TRIPS_PER_STREET = 0 // in trips

export const DEFAULT_MAX_TRIPS_PER_STREET = 100000 // in trips

export const DEFAULT_MIN_SPEED = {
  [SpeedUnit.KilometersPerHour]: SETTINGS.app.filter_trips_min_speed_km_h,
  [SpeedUnit.MilesPerHour]: Math.round(SETTINGS.app.filter_trips_min_speed_km_h * KM_TO_MILES),
  [SpeedUnit.MetersPerSecond]: Math.round(SETTINGS.app.filter_trips_min_speed_km_h * KMH_TO_MS),
}

export const DEFAULT_MAX_SPEED = {
  [SpeedUnit.KilometersPerHour]: SETTINGS.app.filter_trips_max_speed_km_h,
  [SpeedUnit.MilesPerHour]: Math.round(SETTINGS.app.filter_trips_max_speed_km_h * KM_TO_MILES),
  [SpeedUnit.MetersPerSecond]: Math.round(SETTINGS.app.filter_trips_max_speed_km_h * KMH_TO_MS),
}
